<template>
  <header_en_m/>
  <Contact_index_en_m/>
  <Contact_page_en_m/>
  <Footer_en_m/>

</template>
<script>
import Header_en_m from "@/components/EN_mobile/Header_en_m";
import Contact_index_en_m from "@/components/EN_mobile/contact/Contact_index_en_m";
import Contact_page_en_m from "@/components/EN_mobile/contact/Contact_page_en_m";
import Footer_en_m from "@/components/EN_mobile/Footer_en_m";

export default {
  name: 'Contact_en_m',
  components: {
    Footer_en_m,
    Contact_page_en_m,
    Contact_index_en_m,
    Header_en_m,
  }
}
</script>
<style scoped>

</style>

